// extracted by mini-css-extract-plugin
export default {"root":"Footer_root__jmXtJ","copyright":"Footer_copyright__2WB24","link":"Footer_link__sgKeT","first":"Footer_first__rBh2n"};